module.exports = __webpack_public_path__ + "static/media/checkmark_circle_white.1ec3026f.svg";